import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { APP_ROUTES } from '@app/app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { TranslationService } from '@services/translation/translation.service';
import { provideLottieOptions } from 'ngx-lottie';
import { AmplitudeService } from '@services/amplitude/amplitude.service';
import { provideRouter, withComponentInputBinding, withPreloading, PreloadAllModules } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, '/assets/i18n/', '.json');

export const provideTranslation: () => {
  loader: {
    provide: typeof TranslateLoader;
    useFactory: (http: HttpClient) => TranslateHttpLoader;
    deps: [typeof HttpClient];
  };
} = () => ({
  loader: {
    provide: TranslateLoader,
    useFactory: httpLoaderFactory,
    deps: [HttpClient],
  },
});

export function initializeTranslation(): () => void {
  const translateService: TranslateService = inject(TranslateService);
  const languageSwitchService: TranslationService = inject(TranslationService);
  return () => {
    translateService.addLangs(TranslationService.availableLanguages);
    translateService.setDefaultLang(TranslationService.defaultLanguage);
    languageSwitchService.initLanguage();
  };
}

export function initializeAmplitude(amplitudeService: AmplitudeService): () => void {
  return () => amplitudeService.init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      APP_ROUTES,
      withComponentInputBinding(), //Permite bindeo de parámetros de ruta a @Inputs
      withPreloading(PreloadAllModules) // Estrategia de precarga para lazy loading
    ),
    provideHttpClient(
      withInterceptors([]) // listar los interceptors
    ),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideClientHydration(),
    importProvidersFrom([TranslateModule.forRoot(provideTranslation())]),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAmplitude,
      deps: [AmplitudeService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslation,
      multi: true,
      deps: [TranslateService],
    },
    provideLottieOptions({
      player: () => import('lottie-web/build/player/lottie_light')
    }),
  ]
};
